import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function StockScreenerPage() {
  useEffect(() => { document.title = 'Stock Screener — 12-Factor Fundamental Screening | Nuvport OS'; }, []);
  return <ScaffoldPage badge="STOCK SCREENER" title="Filter 76 stocks by 12 fundamental metrics." description="Screen by P/E, P/B, EV/EBITDA, revenue growth, profit margins, and more. 5 preset screens included. Find undervalued stocks in minutes." canonical="/features/stock-screener" />;
}
